let supportsPassive = false;

try {
  const opts = Object.defineProperty({}, 'passive', {
    // eslint-disable-next-line getter-return
    get() {
      supportsPassive = true;
    },
  });
  window.addEventListener('testPassive', null, opts);
  window.removeEventListener('testPassive', null, opts);
} catch (e) {
  console.error('Passive event listener check ran with no window.');
}
export function registerPassiveEvent(event, el, fn) {
  el.addEventListener(event, fn, supportsPassive ? { passive: true } : false);
}

export function removePassiveEvent(event, el, fn) {
  el.removeEventListener(event, fn, supportsPassive ? { passive: true } : false);
}
